import React from 'react'

const MyAppointments = () => {
  return (
    <div>MyAppointments</div>
  )
}

export default MyAppointments